import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import VueAnalytics from 'vue-analytics';
import vuetify from './plugins/vuetify';
// import 'roboto-fontface/css/roboto/roboto-fontface.css';
// import '@mdi/font/css/materialdesignicons.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import './registerServiceWorker';
import VueCurrencyFilter from 'vue-currency-filter';
import { LoaderPlugin } from 'vue-google-login';
import VueMeta from 'vue-meta';
import Clipboard from 'v-clipboard';

// use loader plugin google auth
Vue.use(LoaderPlugin, {
  client_id:
    '404766723014-556ceqqifjaf150535o42056a1544phk.apps.googleusercontent.com',
});

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});

Vue.use(VueAnalytics, {
  id: 'UA-171513144-1',
  router,
});

// use currency filter
Vue.use(VueCurrencyFilter, {
  symbol: 'Rp',
  thousandsSeparator: '.',
  fractionCount: 0,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true,
});

// google auth
// Vue.GoogleAuth.then((auth2) => {
//   console.log(auth2.isSignedIn.get());
// });

// use i dont know
Vue.config.productionTip = false;

Vue.use(Clipboard);

new Vue({
  store,
  router,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
